var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "680",
      maxWidth: "680",
      title: _vm.$t(
        "label_essweb_punchCriteriaType_list_dialog_newCriteriaTypeTitle"
      ),
      dialog: _vm.show,
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_shift_form_dialog_criteriaTypeLabel",
                            items: _vm.CriteriaType,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "item-text": "criteria_type_name",
                            "item-value": "uuid",
                          },
                          model: {
                            value: _vm.curTypeuuid,
                            callback: function ($$v) {
                              _vm.curTypeuuid = $$v
                            },
                            expression: "curTypeuuid",
                          },
                        }),
                      ],
                      1
                    ),
                    false
                      ? _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("AutoComplete", {
                              attrs: {
                                label:
                                  "label_essweb_shift_form_dialog_siteNameLabel",
                                items: _vm.SiteList,
                                disabled: "",
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                                "item-text": "site_name",
                                "item-value": "uuid",
                              },
                              model: {
                                value: _vm.curSiteuuid,
                                callback: function ($$v) {
                                  _vm.curSiteuuid = $$v
                                },
                                expression: "curSiteuuid",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_shift_form_dialog_criteriaNameLabel",
                            items: _vm.CriteriaName,
                            "append-icon": _vm.curTypeuuid
                              ? "arrow_drop_down"
                              : "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            disabled: _vm.curTypeuuid ? false : true,
                            "item-text":
                              _vm.criteriaCode == "FACE"
                                ? "criteria_facial_name"
                                : _vm.criteriaCode == "GPS"
                                ? "criteria_gps_name"
                                : _vm.criteriaCode == "WIFI"
                                ? "criteria_wifi_name"
                                : _vm.criteriaCode == "BLUETOOTH"
                                ? "criteria_bluetooth_name"
                                : "",
                            "item-value": "uuid",
                          },
                          model: {
                            value: _vm.curCriteriauuid,
                            callback: function ($$v) {
                              _vm.curCriteriauuid = $$v
                            },
                            expression: "curCriteriauuid",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.newProperty, cancel: _vm.closePorpertyDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }